import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const tracker = window._hsq = window._hsq || [];

const useHubSpotTracking = () => {
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname + location.search;
        tracker.push(['setPath', path]);
        tracker.push(['trackPageView']);
    }, [location]);
}

export default useHubSpotTracking;
